// extracted by mini-css-extract-plugin
export var item = "side-menu-module--item--8a75f";
export var list = "side-menu-module--list--bb46a";